import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'settings';
import {
  APIHandler,
  DataHandler,
  Email,
  Register,
  StorageHandler,
} from 'C4';

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  return inputArray.every(val => val.checkValidity() === true);
};

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: {
        email: '',
        reg_email: '',
        reg_first_name: '',
        reg_last_name: '',
        reg_agency_name: '',
        reg_state: '',
      },
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
      },
      message: '',
      display: 'login',
      redirect: '',
      appId: 0,
    };

    document.body.classList.add('no-scroll');

    StorageHandler.exists(storageKeys.user).then((res) => {
      if (this.props.path !== '/logout' && res) {
        this.setState({ redirect: '/main/' });
      } else {
        StorageHandler.removeKeys(userKeys);
      }
    });

    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
  }

  componentWillMount() {
    DataHandler.matchAppId().then((id) => {
      this.setState({ appId: id });
    });
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    document.querySelector('.form__message').style.color = 'red';
    document.querySelector('.form__message').style.opacity = 1;
    document.querySelector('.form__message').style.color = 'black';
  }

  backHandler() {
    this.setState({
      display: 'login',
      message: '',
    });
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) {
      StorageHandler.save(storageKeys.user, userInfo, 2592000000);
    }
    document.body.classList.remove('no-scroll');
    if (customRedir) {
      this.setState({ redirect: customRedir });
    } else {
      this.setState({ redirect: '/main/' });
    }
  }

  loginHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    if (checkInputValidity()) {
      event.preventDefault();
      const { email } = this.state.userInput;

      StorageHandler.exists(storageKeys.user) // Check if userInfo is in localStorage
        .then((res) => {
          if (!res) {
            this.setAnim('loadingAnim', true);
            DataHandler.matchAppId()
              .then((appId) => {
                APIHandler.getUser(appId, email) // Fetches userInfo object from the API if it's not
                  .then((userInfo) => {
                    submit.disabled = false;
                    if (APIHandler.ok(userInfo.response)) {
                      this.login(userInfo, true);
                    } else {
                      const { userInput } = this.state;
                      userInput.reg_email = email;
                      this.setState({
                        display: 'register',
                        userInput,
                      });
                    }
                  });
              });
          } else {
            StorageHandler.load(storageKeys.user)
              .then((userInfo) => { // Loads userInfo from localStorage
                submit.disabled = false;
                this.login(userInfo, false);
              });
          }
        });
    } else {
      submit.disabled = false;
    }
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value;
    this.setState({ userInput: input });
  }

  registerHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    StorageHandler.exists(storageKeys.user).then((res) => {
      if (!res && checkInputValidity()) {
        this.setAnim('loadingAnimRegister', true);
        const info = this.state.userInput;
        const registerObject = {
          first_name: info.reg_first_name,
          last_name: info.reg_last_name,
          agency_name: info.reg_agency_name,
          state: info.reg_state,
        };

        DataHandler.matchAppId()
          .then((appId) => {
            APIHandler.getUser(appId, info.reg_email).then((userInfo) => {
              if (!APIHandler.ok(userInfo.response)) {
                APIHandler.setUser(info.reg_email, this.state.appId, registerObject).then(() => {
                  APIHandler.getUser(appId, info.reg_email).then((newUser) => {
                    submit.disabled = false;
                    this.login(newUser, true, '/main');
                  });
                });
              } else {
                submit.disabled = false;
                this.setAnim('loadingAnimRegister', false);
                this.setMessage(i18n.translate('loginScreen.registered'));
              }
            });
          });
      } else {
        submit.disabled = false;
      }
    });
  }

  render() {
    const {
      animation,
      display,
      message,
      redirect,
      userInput,
    } = this.state;

    return (
      <form className="login__form">
        {display === 'login' && <Email
          submit={this.loginHandler}
          defaultVal={userInput.email}
          change={this.changeHandler}
          loadingAnim={animation.loadingAnim}
        />}

        {display === 'register' && <Register
          back={this.backHandler}
          defaultVal={userInput.email}
          submit={this.registerHandler}
          change={this.changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />}

        <h3 className="form__message">{message}</h3>

        {redirect.length > 0 && <Redirect push to={redirect} />}
        <p className="legal">
          {i18n.translate('loginScreen.tAndC.agree')}
          <span
            role="button"
            tabIndex={-1}
            data-fancybox="privacy"
            data-type="iframe"
            href="https://travpromobile.com/privacy_policy.html"
          >{i18n.translate('loginScreen.tAndC.privacyPolicy')}
          </span>
          {i18n.translate('loginScreen.tAndC.and')}
          <span
            role="button"
            tabIndex={0}
            data-fancybox="terms"
            data-type="iframe"
            href="https://travpromobile.com/terms_of_use.html"
          >{i18n.translate('loginScreen.tAndC.termsConditions')}
          </span>.
        </p>
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
